const puzzle = {
  id: "wpcQpBgIAGToEsmSwPfo",
  name: "Little Yellow Running Through",
  rebuses: [
    {
      style: {},
      clues: [
        {
          helperText: "Type in the correct numbers.",
          dependsOn: [],
          subtext: "",
          id: "99aca5c9-2007-4a05-ae5b-ec985d81b26d",
          clueValues: [
            {
              value: "GuitarCounterXCoordinate",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "customComponent",
              id: "9552ca86-6da5-4565-91c1-0138d9152dbb",
            },
          ],
          style: {
            width: "calc(50% - 10px)",
          },
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [
              {
                value: "",
                id: "58aaaeee-8353-441d-8c89-748259e788c8",
              },
            ],
            type: "customComponent",
            solvedText: "",
          },
        },
        {
          style: {
            width: "calc(50% - 10px)",
          },
          dependsOn: [],
          subtext: "",
          clueValues: [
            {
              subtext: "",
              value: "GuitarCounterYCoordinate",
              type: "customComponent",
              id: "10129706-1192-4e80-a632-0c5ecc3866c4",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          solutionInfo: {
            type: "customComponent",
            possibleSolutions: [
              {
                value: "",
                id: "e541a481-a961-492e-a8cc-acd7638d574e",
              },
            ],
            solvedText: "",
          },
          id: "82b1aec5-b08d-49b3-aa30-d1ff5b174216",
          clueGroup: 0,
          helperText: "Type in the correct numbers.",
        },
        {
          clueGroup: 0,
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          id: "43821aff-e46d-4198-a16e-5c20366ddfd7",
          clueValues: [
            {
              style: {
                width: "calc(50% - 10px)",
              },
              type: "image",
              value: "RL7Vmm5S.png",
              subtext: "-33.867, -63.987",
              id: "fcd19b5c-7bc6-4427-aa32-e71b760d08d4",
            },
          ],
          helperText:
            "Find out what instrument can be found at given coordinates.",
          dependsOn: [
            {
              id: "99cbd0a1-9900-4bba-b13e-ecc37b3e9df1",
              value: "99aca5c9-2007-4a05-ae5b-ec985d81b26d",
            },
            {
              value: "82b1aec5-b08d-49b3-aa30-d1ff5b174216",
              id: "c88726d8-dae2-49ca-892b-e385d1b4c2f4",
            },
          ],
          subtext: "Instrument",
          style: {
            width: "calc(50% - 10px)",
          },
        },
      ],
      id: "7d67c062-57da-4a8d-8b7d-05f34a7c4e48",
      solutionInfo: {
        type: "text",
        solvedText: "Guitar",
        possibleSolutions: [
          {
            value: "Guitar",
            id: "0b0bbcaa-7906-4207-b328-f61327a6c2ff",
          },
        ],
      },
    },
    {
      style: {},
      clues: [
        {
          subtext: "",
          id: "4a1b532c-d767-4d6d-8334-0abc25d7eb1e",
          style: {
            width: "calc(77% - 10px)",
          },
          helperText: "Connect all lightbulbs.",
          clueValues: [
            {
              type: "customComponent",
              value: "CarCircuits",
              subtext: "",
              id: "6744dd56-038b-4e1d-84ac-36cccfb358d2",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          dependsOn: [],
          clueGroup: 0,
        },
      ],
      solutionInfo: {
        possibleSolutions: [
          {
            value: "Car",
            id: "683ee019-fc41-4e75-9e6a-77b9deaf36ba",
          },
        ],
        type: "text",
        solvedText: "Car",
      },
      id: "137940b6-c903-466c-aeee-8f3639960ae1",
    },
    {
      style: {},
      solutionInfo: {
        possibleSolutions: [
          {
            value: "Toothbrush",
            id: "21767ce4-4f97-4291-9c95-29c09fe7a1df",
          },
        ],
        type: "text",
        solvedText: "Toothbrush",
      },
      id: "77866f52-f5aa-4123-b88e-7eefa73a1030",
      clues: [
        {
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          clueValues: [
            {
              subtext: "doesn't need it",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Edentulous person",
              id: "ac40105b-0cb4-4f4a-a3da-fec7f8689a7d",
            },
          ],
          helperText:
            "You use it twice a day (hopefully), in the morning and in the evening.",
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          clueGroup: 0,
          id: "fa5bde23-03ec-459e-baff-223fc05ca00f",
          subtext: "",
        },
      ],
    },
    {
      solutionInfo: {
        solvedText: "Electric",
        possibleSolutions: [
          {
            id: "09fa862b-ed47-401f-8f6b-4d194d6bbfda",
            value: "Electric",
          },
          {
            id: "a93f1c54-2e75-4d73-ad94-c66a06cdaa8d",
            value: "Electronic",
          },
        ],
        type: "text",
      },
      id: "c77ba455-d4f6-43d6-bb5a-55e511c98339",
      style: {},
      clues: [
        {
          clueGroup: 0,
          subtext: "",
          style: {
            width: "calc(41% - 10px)",
          },
          clueValues: [
            {
              value: "ElectricVennDiagram",
              id: "56d4ffc2-ba54-44ea-b04d-08a6384cdb77",
              subtext: "Type",
              type: "customComponent",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "19a3b33f-714f-4fe8-b682-beb2cbeac4c6",
          helperText:
            "Car - these types of cars are getting more and more popular. Guitar - Find out what types of guitar there are. Toothbrush - it uses a battery. ",
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            type: "customComponent",
            possibleSolutions: [
              {
                id: "7ec3c79b-4e54-4369-91d1-820f9c32c1b4",
                value: "",
              },
            ],
          },
        },
      ],
    },
  ],
};

export default puzzle;
